import clsx from 'clsx'
import { JSX } from 'react'
import { TbCircleCheckFilled, TbX } from 'react-icons/tb'
import { Stack } from '~/components-v2'

type CompareItemProps = {
  type: 'positive' | 'negative'
  children: JSX.Element
}

export const CompareItem = ({ type, children }: CompareItemProps) => {
  return (
    <Stack
      row
      as="div"
      className={clsx('compare-item', `compare-type-${type}`)}
      gap={2}
    >
      <div className="compare-item-icon">
        {type == 'positive' ? (
          <TbCircleCheckFilled color="var(--color-success)" size="20" />
        ) : (
          <TbX color="var(--color-critical)" size="20" />
        )}
      </div>
      <div className="compare-item-content">{children}</div>
    </Stack>
  )
}
